import React, { useState } from 'react';
import { TextInput } from '@vp/swan';
import PropTypes from 'prop-types';

export const ActiveCartControl = ({ setInternalCartViewShopperId }) => {
  const [shopperIdInput, setShopperIdInput] = useState('');
  const loadShopperCart = event => {
    if (event.key === 'Enter') {
      setInternalCartViewShopperId({ shopperId: shopperIdInput });
    }
  };

  const onShopperIdEntered = event => {
    setShopperIdInput(event.target.value.trim());
  };

  return (
    <TextInput
      id="shopperIdEntryInternalview"
      size="standard"
      label="Enter a shopper ID then hit Enter"
      onChange={onShopperIdEntered}
      onKeyPress={loadShopperCart}
    />
  );
};

ActiveCartControl.propTypes = {
  setInternalCartViewShopperId: PropTypes.func.isRequired,
};
